export const FitnessLevelsEnum = {
  SEDENTARY: "sedentary",
  LIGHT: "light",
  ACTIVE: "active",
  VERY_ACTIVE: "very_active",
  ATHLETE: "athlete",
};